// 匯出菜單表單元件
import { Form, DatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_TW';
import 'dayjs/locale/zh-tw';
import { FormInstance } from 'antd/es/form/Form';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import { LocationSelectorContainer } from '../shared/location-selector';

type Props = {
  form: FormInstance;
};

export function ExportMenuFormComponent(props: Props) {
  useEffect(() => {
    props.form.resetFields();
  }, [props.form]);

  return (
    <Form
      form={props.form}
      initialValues={{
        date: dayjs().startOf('day'),
        locationIds: [],
      }}
    >
      <Form.Item>
        <div>請選擇要匯出的取貨日期。</div>
        <div className="text-red-400">
          匯出可能需要 1 到 2 分鐘，請不要關閉瀏覽器。
        </div>
      </Form.Item>
      <Form.Item
        label="日期"
        name="date"
        rules={[{ required: true, message: '請選擇日期' }]}
      >
        <DatePicker locale={locale} />
      </Form.Item>
      <LocationSelectorContainer multiple />
    </Form>
  );
}
